// Brightcove player URL pattern
export const BRIGHTCOVE_PLAYER_URL_PATTERN =
  'https://players.brightcove.net/{accountId}/{playerId}/index.html?videoId={videoId}';

export const isValidBrightcoveUrl = (url: string): boolean => {
  // Check for full player URL format only
  const playerPattern = /^https:\/\/players\.brightcove\.net\/\d+\/[a-zA-Z0-9_-]+\/index\.html\?videoId=\d+$/;
  return playerPattern.test(url);
};

export const extractVideoId = (url: string): string | null => {
  // Extract from player URL
  const playerMatch = url.match(/videoId=(\d+)/);
  return playerMatch ? playerMatch[1] : null;
};

export const formatBrightcoveUrl = (accountId: string, playerId: string, videoId: string): string => {
  return `https://players.brightcove.net/${accountId}/${playerId}/index.html?videoId=${videoId}`;
};

export const getBrightcoveUrlType = (url: string): 'player' | 'invalid' => {
  if (/^https:\/\/players\.brightcove\.net\/\d+\/[a-zA-Z0-9_-]+\/index\.html\?videoId=\d+$/.test(url)) {
    return 'player';
  }
  return 'invalid';
};

export const parseBrightcoveUrl = (
  url: string
): { accountId: string; playerId: string; embedId?: string; videoId: string } | null => {
  const urlType = getBrightcoveUrlType(url);

  if (urlType === 'player') {
    // Parse player URL: https://players.brightcove.net/104403126001/default_default/index.html?videoId=6336623568112
    // Format is: accountId/playerId_embedId/index.html?videoId=videoId
    const urlParts = url.match(/players\.brightcove\.net\/(\d+)\/([^\/]+)\/index\.html\?videoId=(\d+)/);
    if (!urlParts) {
      return null;
    }

    // Split playerId_embedId
    const playerIdParts = urlParts[2].split('_');
    const playerId = playerIdParts[0];
    const embedId = playerIdParts[1] || undefined;

    return {
      accountId: urlParts[1],
      playerId,
      embedId,
      videoId: urlParts[3],
    };
  }

  return null;
};

